import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { AlertDialogService } from 'src/app/Services/Alert/alert.service';
import { CommonService } from 'src/app/Services/Common/common.service';
import { CommonGridService } from 'src/app/Services/Common/grid.service';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
declare var $: any;

@Component({
  selector: 'app-addcareer',
  templateUrl: './addcareer.component.html',
  styleUrls: ['./addcareer.component.css']
})
export class AddcareerComponent implements OnInit {
  WebAPImasteruri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  CareerForm: FormGroup;
  RegionList:any;
  CategoryList:any;
  today = new Date();
  config: any = {
    airMode: false,
    tabDisable: true,
    popover: {
      table: [
        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
      ],
      image: [
        ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
        ['float', ['floatLeft', 'floatRight', 'floatNone']],
        ['remove', ['removeMedia']],
      ],
      link: [['link', ['linkDialogShow', 'unlink']]],
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'clear',
          ],
        ],
      ],
    },
    height: '290px',
    uploadImagePath: '/api/upload',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear',
        ],
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']],
      ['customButtons', ['testBtn']],
    ],

    codeviewFilter: true,
    codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    codeviewIframeFilter: true,
  };
  editorDisabled = false;
  
   constructor(
     private formBuilder: FormBuilder,
     private property: PropertiesService,
     public commonService: CommonService,
     private http: HttpClient,
     private gridService: CommonGridService,
     private datePipe: DatePipe,
     private httpRequestService: HttpRequestService,
     private alert: AlertDialogService,
     private route: ActivatedRoute
   ) { this.createForm(); }
 
   createForm() {
     this.CareerForm = this.formBuilder.group({
      JobID: [],
      RegionID: [],
      CategoryID: [],
      Position: [],
      ValidFrom: [],
      ValidTo: [],
      JobDescription: [],
      isPriority: [],
      isActive: []
     });
   }
 
   ngOnInit(): void {
    this.CareerForm.get("ValidFrom").setValue(this.today);
    this.CareerForm.get("ValidTo").setValue(this.today);
     this.getRegionList();
     this.getCategoryList();
     this.route.queryParams.subscribe(params => {
      if (params.JobID) {
        this.GetJobData(params.JobID);
      }
    });
   }

   GetJobData(JobID) {

    this.GetJob(JobID).then((list: any) => {
      let headerDetails: any;
      headerDetails = list.result.Table;

      this.CareerForm.get("JobID").setValue(headerDetails[0].JobID);
      this.CareerForm.get("RegionID").setValue(headerDetails[0].RegionID);
      this.CareerForm.get("CategoryID").setValue(headerDetails[0].CategoryID);
      this.CareerForm.get("Position").setValue(headerDetails[0].Position);
      this.CareerForm.get("ValidFrom").setValue(headerDetails[0].ValidFrom);
      this.CareerForm.get("ValidTo").setValue(headerDetails[0].ValidTo);
      this.CareerForm.get("JobDescription").setValue(headerDetails[0].JobDescription);
      this.CareerForm.get("isPriority").setValue(headerDetails[0].isPriority);
      this.CareerForm.get("isActive").setValue(headerDetails[0].isActive);
     
    });

  }

  GetJob(JobID) {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.WebAPImasteruri + "/Job_List/Get_Job_List?JobID=" + JobID)
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }
 
   getRegionList() {
     return new Promise((resolve) => {
       this.http.get(this.WebAPImasteruri + '/item-activity/item-activity-auto', { params: { value: "CR REGION",search:"%" } }).subscribe((res: any) => {
 //console.log(res);
         if (res != null) {
           resolve(res.body);
           this.RegionList = res.result.Table;
         }
         else {
           alert("No Records Found")
         }
       });
     });
   }

   getCategoryList() {
    return new Promise((resolve) => {
      this.http.get(this.WebAPImasteruri + '/item-activity/item-activity-auto', { params: { value: "CR JOB CAT",search:"%" } }).subscribe((res: any) => {

        if (res != null) {
          resolve(res.body);
          this.CategoryList = res.result.Table;
        }
        else {
          alert("No Records Found")
        }
      });
    });
  }

  onBlur() {
    // console.log('Blur');
  }

  onDelete(file) {
    // console.log('Delete file', file.url);
  }
 
  Save() {
    var frmObj = this.CareerForm.getRawValue();
    frmObj.UpdatedBy = this.property.userId;
    if (!frmObj.JobID) {
      delete frmObj.JobID;
      frmObj.CreatedBy = this.property.userId;
    }
    if (!frmObj.RegionID) {
      delete frmObj.RegionID;
    }
    if (!frmObj.CategoryID) {
      delete frmObj.CategoryID;
    }
    if (!frmObj.Position) {
      delete frmObj.Position;
    }
    if (!frmObj.ValidFrom) {
      delete frmObj.ValidFrom;
    }else {
      frmObj.ValidFrom = this.datePipe.transform(frmObj.ValidFrom, 'MM-dd-yyyy');
    }
    if (!frmObj.ValidTo) {
      delete frmObj.ValidTo;
    }else {
      frmObj.ValidTo = this.datePipe.transform(frmObj.ValidTo, 'MM-dd-yyyy');
    }
    if (!frmObj.JobDescription) {
      delete frmObj.JobDescription;
    }
    if (!frmObj.isPriority) {
      delete frmObj.isPriority;
    }
    else {
      frmObj.isPriority = 1;
    }
    if (!frmObj.isActive) {
      delete frmObj.isActive;
    }
    else {
      frmObj.isActive = 1;
    }

    this.httpRequestService.postBSS(this.WebAPImasteruri + "/Job_List/Update_Job_List", frmObj).then((response: any) => {

      if (response.status == 200) {
        if (response.result.Table[0].Number) {
          this.alert.openSnackBar(response.result.Table[0].Message + ' ' + response.result.Table[0].Number, '1');
        } else {
          this.alert.openSnackBar(response.result.Table[0].Message, '1');
        }
        this.Clear();
      } else if (response.status == 400) {
        this.alert.openSnackBar(response.result, '');
      }
    }, (error: any) => {
    });
  }

  Clear() {
    this.CareerForm.reset();
    this.CareerForm.enable();
    this.CareerForm.get("ValidFrom").setValue(this.today);
    this.CareerForm.get("ValidTo").setValue(this.today);
  }

 }
 